export const LINE_HEIGHT = 16;
export const TICK_HEIGHT = 24;
export const TICK_PADDING = 16;
export const FONT_SIZE = 30;
export const BOTTOM_AXIS_HEIGHT =
  LINE_HEIGHT + TICK_PADDING + TICK_HEIGHT + TICK_PADDING + FONT_SIZE;
export const CORRECT_ANSWER_ANIMATION_DURATION = 500;
export const SVG_INNER_WIDTH_PADDING = 36;
